const SOLUTION_ID_KEY = 'osr_solutionId';
const ORG_ID_KEY = 'osr_orgId';

export const setStoredSolutionId = (solutionId: string): void => {
  if (!solutionId) {
    return;
  }
  localStorage.setItem(SOLUTION_ID_KEY, solutionId);
};

export const getStoredSolutionId = (): string | null => localStorage.getItem(SOLUTION_ID_KEY);

export const setStoredOrgId = (orgId: string): void => {
  if (!orgId) {
    return;
  }
  localStorage.setItem(ORG_ID_KEY, orgId);
};

export const getStoredOrgId = (): string | null => localStorage.getItem(ORG_ID_KEY);
